import { Injectable } from '@angular/core';
import { UserInitializer } from './/user/initializers/user-initializer';
import { UserDataSyncInitializer } from './/user/initializers/user-data-sync.initializer';
import { PlatformNotificationsInitializer } from '@/app/platform/platform-core/platform-notifications/platform-notifications-initializer';

// We could also just inject all separate initializers in it's own module but in this way we can control the order of initializing.

@Injectable({ providedIn: 'root' })
export class PlatformInitializer {
  constructor(
    private readonly userInitializer: UserInitializer,
    private readonly userDataSyncInitializer: UserDataSyncInitializer,
    private readonly platformNotificationsInitializer: PlatformNotificationsInitializer
  ) {}

  async init() {
    await this.userInitializer.init();
    // Na de user-load (JWT beschikbaar) en vóór de eerste render, zodat
    // pagina's gehydrateerde settings/state uit localStorage lezen.
    await this.userDataSyncInitializer.init();
    await this.platformNotificationsInitializer.init();
  }
}
